<template>
    <button
      class="footer-button"
      :class="{'footer-button-1': buttonType === 1,
          'footer-button-2': buttonType === 2,
          'footer-button-3': buttonType === 3
          }"
      @click="buttonClick"
    >
      <div>{{buttonData.name}}</div>
    
    </button>
</template>

<script>
export default {
    name: 'FooterButton',
    props: {
      buttonData: {},
      buttonType: String
    },
    computed: {
        
    },
    methods: {
      buttonClick(){
        this.$emit('buttonClick', this.buttonData.action)
      }
    }
}
</script>

<style>
  
</style>